import { render, staticRenderFns } from "./parameter-merge.vue?vue&type=template&id=e8ec6fc8&scoped=true"
import script from "./parameter-merge.vue?vue&type=script&lang=js"
export * from "./parameter-merge.vue?vue&type=script&lang=js"
import style0 from "./parameter-merge.vue?vue&type=style&index=0&id=e8ec6fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ec6fc8",
  null
  
)

export default component.exports